import { invokeApi } from "../../bl_libs/invokeApi";

export const PodsListing = async (data) => {
  const requestObj = {
    path: `api/room`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const PodsDetailApi = async (room_slug) => {
  const requestObj = {
    path: `api/room/detail/${room_slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
